import { ChevronDown } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgCheveronDown = mkIcon(ChevronDown);